<template>
    <q-card class="producto-list-item cursor-pointer" @click="$emit('add')" flat bordered>
        <div class="row no-wrap items-center">
            <div class="col-auto">
                <q-img :src="imgSrc" alt="product image" fit="contain" loading="lazy"
                    style="width: 120px; height: 120px" class="rounded-borders">
                    <template v-slot:error>
                        <div class="full-width full-height column items-center justify-center bg-grey-2">
                            <q-icon name="broken_image" size="32px" color="grey-5" />
                        </div>
                    </template>
                </q-img>
            </div>

            <div class="col q-pa-md">
                <div class="row items-start">
                    <div class="col">
                        <div class="row items-center">
                            <h4 class="text-h6 q-mr-md">{{ titulo }}</h4>
                            <q-badge v-if="grupo" :style="`background-color: ${useStringToColor(grupo)};`">
                            {{ grupo }}
                            </q-badge>
                        </div>
                        <p class="text-body2 text-grey-7 q-mb-sm">{{ descripcion }}</p>
                    </div>

                    <div class="col-auto text-right">
                        <div class="text-h5 text-primary text-weight-bold q-mb-sm">
                            {{ numberFormat(precio) }}
                        </div>
                        <q-btn color="primary" icon="add_shopping_cart" label="Agregar" @click.stop="$emit('add')" />
                    </div>
                </div>
            </div>
        </div>

        <q-ripple color="primary" />
    </q-card>
</template>

<script setup>
import { computed } from "vue";
import numberFormat from "@/helpers/numberFormat";
import { usePage } from '@inertiajs/vue3'
import { useStringToColor } from "@/composables/useStringToColor";

const page = usePage()

const props = defineProps({
    titulo: [String],
    descripcion: [String],
    grupo: [String],
    id: [String, Number],
    precio: [Number, String],
    imagenesPath: [String],
});

defineEmits(["add"]);

const imgSrc = computed(() => `${props.imagenesPath}/${props.titulo}.webp`);
const noImagePath = page.props.noImagePath;
</script>

<style lang="scss" scoped>
.producto-list-item {
    transition: all 0.2s ease;

    &:hover {
        border-color: var(--q-primary);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
}
</style>
